// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__oWoIT","title":"Video_title__jbjBI","readMore":"Video_readMore__3lDeE","socialButtons":"Video_socialButtons__Kyus2"};